import { RefreshCcw } from 'lucide-react'
import React, { ReactNode } from 'react'
import { Button } from '../ui/button'
import Loader from '@/components/ui_custom/loader'

interface MetricCardProps {
  title: string
  value: string | number
  description?: string
  icon: ReactNode
  color?: string
  onReload?: () => void
  isLoading?: boolean
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, description, icon, color = 'indigo', onReload, isLoading = false }) => {
  // Tokens semânticos da nova paleta. Aliases legados (indigo/purple/blue/green) mantidos para compat.
  const colorClasses: Record<string, string> = {
    primary: 'bg-primary/15 text-coentro',
    accent: 'bg-accent/15 text-jenipapo',
    secondary: 'bg-secondary text-coentro',
    coentro: 'bg-coentro/10 text-coentro',
    destructive: 'bg-destructive/10 text-destructive',
    // Aliases legados → paleta nova
    indigo: 'bg-primary/15 text-coentro',
    purple: 'bg-accent/15 text-jenipapo',
    blue: 'bg-accent/15 text-jenipapo',
    green: 'bg-primary/15 text-coentro'
  }

  const bgColor = colorClasses[color] || colorClasses.primary

  return (
    <div className="bg-card rounded-2xl border border-border/60 shadow-card p-6 transition-all duration-200 hover-lift">
      <div className="flex items-center ">
        <div className={`p-3 rounded-full mr-4 ${bgColor}`}>{icon}</div>
        <div>
          {isLoading ? (
            <Loader variant="spinner" size="sm" color="hsl(var(--primary))" />
          ) : (
            <>
              <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
              <p className="text-2xl font-bold text-foreground mt-1">{value}</p>
              {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
            </>
          )}
        </div>

        {onReload && (
          <Button variant="outline" size="sm" onClick={onReload} className="mt-1 ml-auto border-primary/40 hover:bg-primary/10">
            <RefreshCcw className="h-4 w-4 text-primary" />
          </Button>
        )}
      </div>
    </div>
  )
}

export default MetricCard
